import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const MostSaleProduct = () => {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const URL = process.env.REACT_APP_URL;
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    axios
      .get(`${URL}mostproduct`)
      .then((response) => {
        setProducts(response.data);
      })
      .catch((error) => {
        enqueueSnackbar(`Failed to fetch products: ${error.message}`, {
          variant: "error",
        });
      });
  }, [URL, enqueueSnackbar]);

  const deleteProduct = async (id) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete this product?`
    );
    if (!confirmed) return;

    try {
      const response = await axios.delete(`${URL}mostproduct/${id}`);
      if (response.status === 200) {
        setProducts(products.filter((product) => product.id !== id));
        enqueueSnackbar("Product deleted successfully!", {
          variant: "success",
        });
      } else {
        enqueueSnackbar("Failed to delete the product", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar(`${error.message}`, { variant: "error" });
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const filteredProducts = products.filter((product) =>
    product.title.toLowerCase().includes(search.toLowerCase())
  );
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredProducts.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="p-4 md:p-8">
      <div className="mb-6 flex justify-between items-center">
        <Link to="/add-mostProduct">
          <button className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-700">
            Add Product
          </button>
        </Link>
        <h1 className="text-3xl font-bold text-gray-800">
          Highlights Products
        </h1>
      </div>

      <div className="flex justify-between items-center mb-6">
        <div className="w-full md:w-1/2 mb-4 md:mb-0">
          <input
            type="text"
            placeholder="Search products..."
            value={search}
            onChange={handleSearch}
            className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex items-center space-x-4">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-4 py-2 border border-gray-300 rounded-md text-white ${
              currentPage === 1
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
          >
            Previous
          </button>
          <span className="px-3 py-2 text-sm">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 border border-gray-300 rounded-md text-white ${
              currentPage === totalPages
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
          >
            Next
          </button>
        </div>
      </div>

      <div className="overflow-x-auto bg-white shadow-md rounded-lg">
        <table className="table-auto w-full border-collapse text-left">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2 text-sm font-semibold text-gray-600">
                #
              </th>
              <th className="px-4 py-2 text-sm font-semibold text-gray-600">
                Title
              </th>
              <th className="px-4 py-2 text-sm font-semibold text-gray-600">
                Image
              </th>
              <th className="px-4 py-2 text-sm font-semibold text-gray-600">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((product, index) => (
                <tr key={product.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2">{indexOfFirstItem + index + 1}</td>
                  <td className="px-4 py-2">{product.title}</td>
                  <td className="px-4 py-2">
                    <img
                      src={`${URL}upload/${product.image}`}
                      alt={product.title}
                      className="w-16 h-16 object-cover rounded"
                    />
                  </td>
                  <td className="px-4 py-2">
                    <div className="flex space-x-2">
                      <Link to={`/viewMostProduct/${product.id}`}>
                        <button className="px-3 py-1 bg-blue-500 text-white rounded-lg hover:bg-blue-600 text-sm">
                          View
                        </button>
                      </Link>
                      <Link to={`/editMostProduct/${product.id}`}>
                        <button className="px-3 py-1 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 text-sm">
                          Edit
                        </button>
                      </Link>
                      <button
                        onClick={() => deleteProduct(product.id)}
                        className="px-3 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600 text-sm"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="4"
                  className="text-center py-4 text-sm text-gray-500"
                >
                  No products found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MostSaleProduct;
